import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext, lazy, Suspense } from 'react';
import classnames from 'classnames';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import retry from '../utils/webpack/chunkRetry';
import s from './Notifications.scss';
const DesktopNotificationAnimator = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "notifs" */ './_partials/DesktopNotificationAnimator')));
const MobileNotificationAnimator = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "notifs" */ './_partials/MobileNotificationAnimator')));
const Notifications = (_param)=>{
    var { queue, wrapperClassName, animatorClassName } = _param, props = _object_without_properties(_param, [
        "queue",
        "wrapperClassName",
        "animatorClassName"
    ]);
    // react-spring leaks in ssr, so must avoid rendering it
    const mounted = useIsMounted();
    const isMobile = useContext(MobileContext);
    if (!mounted || queue.length === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], wrapperClassName)
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: null
    }, isMobile ? /*#__PURE__*/ React.createElement(MobileNotificationAnimator, {
        queue: queue,
        notificationProps: props,
        className: animatorClassName
    }) : /*#__PURE__*/ React.createElement(DesktopNotificationAnimator, {
        queue: queue,
        notificationProps: props,
        className: animatorClassName
    })));
};
export default Notifications;

//# sourceMappingURL=Notifications.js.map